<template >
	
	<v-dialog slot="activator" v-model="dialog" persistent max-width="600">
        <v-btn slot="activator" icon>
        	<v-icon>share</v-icon>
        </v-btn>
        <v-card class="pb-5" :key="resetAll">
        	<v-toolbar dark color="#455a64"><v-toolbar-title>SHARE COLLECTION - {{collection.collection}}</v-toolbar-title>
        		<v-spacer></v-spacer>
				<v-btn icon @click="resetForm">
					<v-icon>close</v-icon>
				</v-btn>
        	</v-toolbar>
         	<v-card-text class="px-5 pt-5">
         	<v-expansion-panel popout dark class="colorOverride1 elevation-0">
         		<v-expansion-panel-content class="pa-3">
         		<template v-slot:header>			        
				        <div class="white--text">
		                  	<div class="headline">Collaborate</div>
		                  	<span>Share '{{collection.collection}}' collection with viewers and editors you define.</span>
	                  	</div>
			    </template>

		        	<v-card-text class="pb-3 px-4">
		        		<v-flex v-if="showViewers" class="mb-4">
		        			
		    				<EmployeeAutocomplete :key="reset" :light="!darkTheme"
		    					label="Add Viewer (Name, number, or NetID)"  
		    					v-on:return-employee="addViewer" />

		        		</v-flex>
		        		<v-flex v-else>
		        			<v-btn block class="ml-0 black--text" color="#708666" @click="showViewers=true">Add Viewer</v-btn>
		        		</v-flex>

		        		<v-flex v-if="showEditors" >
		        			<EmployeeAutocomplete :key="reset+1000" :light="!darkTheme"
		        				label="Add Editor (Name, number, or NetID)" 
		        				v-on:return-employee="addEditor" />
			        		
		        		</v-flex>
		        		<v-flex v-else>
		        			<v-btn block class="ml-0 black--text" color="#708666" @click="showEditors=true">Add Editor</v-btn>
		        		</v-flex>
		        		<div class="mt-4" v-if="collection.viewers.length > 0 || collection.editors.length > 0">
			        		<div class="mt-2">
			        			<div v-if="collection.viewers.length > 0">Viewers</div>
			        			<v-chip light close v-for="viewer in collection.viewers" :key="viewer.employee_number"
				        			@input="remove(collection.viewers, viewer)">
				        		 	{{viewer.name}}
				        		</v-chip>
				        	</div>	
					        <div class="mt-2">
					        	<div v-if="collection.editors.length > 0">Editors</div>
			        			<v-chip light close v-for="editor in collection.editors" :key="editor.employee_number"
			        				@input="remove(collection.editors, editor)">
				        		 	{{editor.name}}
				        		</v-chip>
				        	</div>	
			        	</div>
			        	<div v-else>
			        		No Editors or Viewers assigned.
			        	</div>
					</v-card-text>
					<v-card-actions v-if="changed">
			          	<v-spacer></v-spacer>
			          	<!-- <v-btn color="green lighten-2" flat @click.native="dialog=false">Cancel</v-btn> -->
			          	<v-btn color="green lighten-2" flat @click.native="updatePermissions">SAVE CHANGES</v-btn>
			        </v-card-actions>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-card-text>

	        <v-card-text class="px-5">

	         	<v-expansion-panel popout dark class="colorOverride3 elevation-0">
	         		<v-expansion-panel-content class="pa-3">
		         		<template v-slot:header>			        
						        <div class="white--text">
				                  	<div class="headline">Share by URL</div>
				                  	<span>'{{collection.collection}}' is viewable by anyone with this link.</span>
			                  	</div>
					    </template>
	         	
			        	<v-card-text class="pb-5 px-4 caption" style="text-decoration: underline;">
			        		<a :href="'/roomcollections/share/' + `${collection.guid}`"><span ref="link">https://interactivefloorplans.arizona.edu/roomcollections/share/{{collection.guid}}</span></a>							 
						</v-card-text>
						
			        	<v-card-actions>
				          	<v-spacer></v-spacer>
				          	<v-btn color="green darken-1" flat 
				          		@click.native="copyLink('https://interactivefloorplans.arizona.edu/roomcollections/share/' + collection.guid)">
				          	COPY LINK
				          	</v-btn>
				          	
				        </v-card-actions>
						 <v-alert type="success" :value="showClipboardSuccess">
                        		Copied to clipborad.
                    	</v-alert>
						<v-alert type="error" :value="showClipboardError">
                        		Could not copy to clipboard.
                    	</v-alert>
		    		</v-expansion-panel-content>
				</v-expansion-panel>
	        </v-card-text>
    	</v-card>

    </v-dialog>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'
import { AUTH_COOKIE } from '@/store/modules/user'
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'

export default {
data: () => ({
	checkbox: false,
	reset: 1,
	resetAll: 1,
	loading: false,
	items: [],
	search: null,
	select: null,
	dialog: false,
	buttonColor: "green lighten-2",
	//shareTo: { name: null, employeeID: null},
	changed: false,
	showEditors: false,
	showViewers: false,
	copyTo: null,
	showClipboardSuccess: false,
	showClipboardError: false
}),

components: { EmployeeAutocomplete },

props: [ 'collection'],

watch: {
	search (val) {
		val && val !== this.select && val.length > 5 && this.querySelections(val)
	},
},

computed: {
		...mapState({ room: 			state => state.space.selectedRoom, 
									darkTheme: 	state => state.ui.darkTheme,
		}),
},

methods: {
...mapActions(['rcUpdateCollection', 'fetchRoomCollections']),

resetForm() {
	this.resetAll=this.resetAll+1
	this.changed = false				
	this.showEditors = false
	this.showViewers = false
	this.copyTo = null
	this.dialog = false	 //this must be last
},

copyLink(value) {
	let text = value;
          navigator.clipboard.writeText(text)
            .then(() => {
			  this.showClipboardSuccess = true
            })
            .catch(err => {
			  this.showClipboardError = true
            });
},

addViewer(value) {
	let insert = { name: value.name, employee_number: value.employeeID, netid: value.netid }
	if (!this.collection.viewers.find((viewer) => viewer.netid == insert.netid )) {  // Enforce Unique
    	this.collection.viewers.push(insert)
	}
	this.reset=this.reset+1
	this.changed = true
},

addEditor(value) {
	let insert = { name: value.name, employee_number: value.employeeID, netid: value.netid }
	if (!this.collection.editors.find((editor) => editor.netid == insert.netid )) {  // Enforce Unique
    	this.collection.editors.push(insert)
	}
	this.reset=this.reset+1
	this.changed = true
},

setCopyTo(value) {
	this.copyTo = value
	this.reset=this.reset+1
},

remove (list, removeMe) {
  	const index = list.indexOf(removeMe)
  	if (index >= 0) list.splice(index, 1)
  	this.changed = true
  	this.showEditors = false
  	this.showViewers = false
},

updatePermissions: function() {				
	this.rcUpdateCollection(this.collection)			
	this.resetForm()
},




querySelections (v) {
	this.loading = true
	console.log("Fetching Employees for Autocomplete")
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	fetch("https://api.ba.arizona.edu/if/employees/" + v,
		{
				headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'apiEsriToken': apiEsriToken
				},
		})
		.then(response => response.json())
		.then(data => { 
			this.items = data 
			this.loading = false
		})
},
}
}
</script>

<style scoped>
.colorOverride1 .v-expansion-panel__container {
  background-color: #5b6d53 !important;
}

.colorOverride2 .v-expansion-panel__container {
  background-color: #c3662b !important;
}

.colorOverride3 .v-expansion-panel__container {
  background-color: #3B1C32 !important;
}

a:link    { color: white }    
a:visited { color: white }   
a:hover   { color: white } 
a:active  { color: white }   

</style>



// WEBPACK FOOTER //
// src/components/forms/ShareCollectionDialog.vue